import Search from '@material-ui/icons/Search'
import styled from 'styled-components'

const Wrapper = styled.div`
  .input-group-text {
    background: transparent;
  }
  .form-control {
    border-left-width: 0px;
    padding-left: 0;
  }
`

const InputWithIcon = ({ icon, onChange, placeholder, ...rest }) => (
  <Wrapper className="input-group">
    <div className="input-group-prepend">
      <span className="input-group-text">{icon}</span>
    </div>
    <input className="form-control" onChange={onChange} placeholder={placeholder} {...rest} />
  </Wrapper>
)

InputWithIcon.defaultProps = {
  icon: <Search />,
  onChange: null,
  placeholder: 'search',
}

export default InputWithIcon
